var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf3fdbcf-6891-414a-901a-f870f06dfbec",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.8034 47.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9251,48.819H.0983V16.3385H10.9251ZM5.5139,12.0078a5.4134,5.4134,0,1,1,5.4112-5.4156A5.415,5.415,0,0,1,5.5139,12.0078ZM49.9017,48.819H39.4928V33.0119c0-3.77-.0715-8.6182-5.4113-8.6182-5.42,0-6.2535,4.1055-6.2535,8.3453v16.08H17.4212V16.3147h9.991v4.4412h.1408c1.39-2.5551,4.7876-5.2489,9.8545-5.2489,10.5454,0,12.4942,6.7322,12.4942,15.4846Z",
    transform: "translate(-0.0983 -1.181)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f3fb3bc0.svg";
export { ForwardRef as ReactComponent };